import React from "react";
import PropTypes from "prop-types";

function HeaderBox({ id = "deq-primary", style: userStyles = {}, children, ...props }) {
  return (
    <div
      style={userStyles}
      className={`textbar w-100 text-center m-2 mb-4 p-1`}
      id={id}
      {...props}
    >
      {children}
    </div>
  );
}

HeaderBox.propTypes = {
  /** Optional theme to color title*/
  id: PropTypes.string,

  /** Optional inline style(s) */
  style: PropTypes.object
};

export default HeaderBox;
